import { render, staticRenderFns } from "./CompactConsentInput.vue?vue&type=template&id=2a4d30b0&"
import script from "./CompactConsentInput.vue?vue&type=script&lang=js&"
export * from "./CompactConsentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports